// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const noticeBoard = defineModel({
  id: "notice-board",
  batchId: "future",
  name: "Notice board",
  tags: ["scenery","notice","board","low-poly","age-of-mcp","future"],
  summary: "A public board posting notices, prices and orders.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.35,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.05, 0.6, 0.05), color: "#6e4f2e", position: [-0.26, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.6, 0.05), color: "#6e4f2e", position: [0.26, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.62, 0.4, 0.04), color: "#8a6840", position: [0, 0.46, 0.02] },
      { geometry: new THREE.BoxGeometry(0.16, 0.18, 0.02), color: "#e6e0cf", position: [-0.16, 0.52, 0.045] },
      { geometry: new THREE.BoxGeometry(0.16, 0.14, 0.02), color: "#e6e0cf", position: [0.12, 0.55, 0.045] },
      { geometry: new THREE.BoxGeometry(0.14, 0.14, 0.02), color: "#e6e0cf", position: [0.02, 0.36, 0.045] },
      { geometry: new THREE.BoxGeometry(0.68, 0.04, 0.169706), color: "#563d22", position: [0, 0.72, 0.06], rotation: [0.785398, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.68, 0.04, 0.169706), color: "#563d22", position: [0, 0.72, -0.06], rotation: [-0.785398, 0, 0] },
    ],
  animations: [],
});
